// extracted by mini-css-extract-plugin
export default {"page-error":"PageError_page-error__JHNvf"};